





















import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import { Prop, Watch } from 'vue-property-decorator';
import Transcription from '../../store/modules/transcription';
import store from '@/store/store';
import * as Diff from 'diff';

const trscModule = getModule(Transcription, store);
@Component
export default class TextAnnotationDialog extends Vue {
  @Prop(Boolean) value!: boolean;

  text = "";

  get show() {
    return this.value;
  }
  set show(value) {
    this.$emit('input', value);
  }

  async save() {
    this.show = false;
    this.text = this.text.replace(/\n/g, " / ");
    this.$emit('saved', this.text);
    this.text = "";
  }
}
